<ui-tabset>
  <ui-tab [uiTitle]="'create_symbol' | localize">
    <div class="team-preview">
      <ui-avatar [uiIcon]="team.avatar" [uiBgColor]="team.color" uiTheme="fill" uiSize="lg"></ui-avatar>
      <h2>{{ team.name }}</h2>
    </div>

    <div class="icons">
      <div class="single-icon" *ngFor="let icon of icons" [ngClass]="{ selected: icon === team.avatar }" (click)="setAvatar(icon)">
        <span [ngClass]="'nc-icon-outline icon ' + icon"></span>
      </div>
    </div>

    <div class="colors">
      <div class="single-color" *ngFor="let color of colors" [style.background]="color" [ngClass]="{ selected: color === team.color }" (click)="setColor(color)"></div>
    </div>
  </ui-tab>

  <ui-tab [uiTitle]="'upload_picture' | localize"> </ui-tab>
</ui-tabset>
